import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_mountain_darkgold/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-97b3d03d32.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-d7743f37cc.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-d4e17ced56.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-e64d209a7c.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-54e4ba5fba.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-f3a57c351b.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-78092d87fd.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-7c87605afe.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-758fe3cfaf.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-b931c99cb4.png'; };
